// Module
var code = "<div class=\"top-container\"> <h3>Pages</h3> <div class=\"toolchain\"> <button class=\"btn-flat icon add-new\" data-test-id=\"add-new-page\" id=\"new_page\"> <span class=\"striimline-icon add\"></span> </button> </div> </div> <ul class=\"pages collection\"></ul> ";
// Exports
export default code;